import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';

import PropTypes from 'prop-types';

import Spinner from '@/components/common/Spinner';
import { formatCredits } from '@/components/SchedulePage/helpers/credits';
import deviceImage from '@/components/SchedulePage/Timeline/InspectorList/icons/device-black.svg';
import inspectionImage from '@/components/SchedulePage/Timeline/InspectorList/icons/inspection-black.svg';
import locationImage from '@/components/SchedulePage/Timeline/InspectorList/icons/location-black.svg';
import creditsIcon from '@/images/icons/credits.svg';
import classes from '@/components/SchedulePage/Timeline/InspectorList/style.module.scss';

const InspectorListComponent = ({ inspectors, busy, scheduledCreditsByInspector }) => {
  const intl = useIntl();
  const getInspectorFeedbackOpacity = useCallback(inspector => {
    const applyLessOpacity = inspector?.wasNotFiltered || inspector?.status === 'DEVICE_NOT_CONNECTED';

    return applyLessOpacity ? 0.5 : 1;
  }, []);

  const getInspectorWarningMessage = useCallback(
    inspector => {
      if (inspector?.status === 'DEVICE_NOT_CONNECTED') {
        return (
          <p className={classes.warningMessage}>
            <img src={deviceImage} alt="dispositivo" />

            <span>Vistoriador sem dispositivo</span>
          </p>
        );
      }

      if (inspector?.pendingOrderBasedMessage) {
        if (inspector?.pendingOrderBasedMessage === 'ORDER_TYPE') {
          return (
            <div className="transition-opacity duration-300">
              <p className={classes.warningMessage}>
                <img src={inspectionImage} alt="Tipo de vistoria" />

                <span>Não faz o tipo de vistoria</span>
              </p>
            </div>
          );
        }

        if (inspector?.pendingOrderBasedMessage === 'ADDRESS') {
          return (
            <div className="transition-opacity duration-300">
              <p className={classes.warningMessage}>
                <img src={locationImage} alt="Bairro" />

                <span>Não atende o bairro</span>
              </p>
            </div>
          );
        }
      }

      return <div />;
    },
    []
  );

  return (
    <div className={classes.inspectorList}>
      <header>
        <h4>Vistoriadores</h4>
      </header>

      {busy ? (
        <div className={classes.spinnerWrapper}>
          <Spinner />
        </div>
      ) : (
        !!inspectors?.length &&
        inspectors.map(inspector => (
          <div className={classes.line} key={inspector?.public_id}>
            <div className={classes.inspector} style={{ opacity: getInspectorFeedbackOpacity(inspector) }}>
              <div className={classes.name} title={inspector?.name}>
                {inspector?.name}
              </div>
              <div className={classes.document} title={inspector?.document}>
                {inspector?.document}
              </div>

              {!!scheduledCreditsByInspector[inspector?.public_id] && (
                <div
                  className={classes.scheduledCredits}
                  title={intl.formatMessage({ id: 'Financial.credits' })}
                  aria-label={`${intl.formatMessage({ id: 'Financial.credits' })}: ${formatCredits(
                    scheduledCreditsByInspector[inspector?.public_id]
                  )}`}
                >
                  <img src={creditsIcon} alt="" />
                  <span>{formatCredits(scheduledCreditsByInspector[inspector?.public_id])}</span>
                </div>
              )}

              {inspector?.region && <div className={classes.location}>{inspector?.region}</div>}

              {getInspectorWarningMessage(inspector)}
            </div>
          </div>
        ))
      )}
    </div>
  );
};

InspectorListComponent.propTypes = {
  busy: PropTypes.bool.isRequired,
  inspectors: PropTypes.array,
  scheduledCreditsByInspector: PropTypes.object.isRequired,
};

InspectorListComponent.defaultProps = {
  inspectors: null,
};

export default InspectorListComponent;
